import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Core_Document_Verification.css';

const Core_Document_Verification = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"CORE_DOCUMENT_VERIFICATION",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	CORE_DOCUMENT_VERIFICATION:-1
  });


  const [CORE_DOCUMENT_VERIFICATION, setCORE_DOCUMENT_VERIFICATION] = React.useState(null);
  const [CORE_DOCUMENT_VERIFICATION_D, setCORE_DOCUMENT_VERIFICATION_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Core Document Verification');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Core_Document_Verification',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewCORE_DOCUMENT_VERIFICATION(clientInfo,"OpenNew");

		navigate('/Core_Document_Verification',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Document_Verification_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutCORE_DOCUMENT_VERIFICATION(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostCORE_DOCUMENT_VERIFICATION(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewCORE_DOCUMENT_VERIFICATION(clientInfo,"OpenNew");
		}
		navigate('/Core_Document_Verification',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Document_Verification_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Document_Verification_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Document_Verification_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
		if(Temp_Data2.status!="New"){
			handleDeleteCORE_DOCUMENT_VERIFICATION(Temp_Data2);
			navigate('/Core_Document_Verification#New',{replace:true});
		} 
		else 
			navigate('/Core_Document_Verification',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Document_Verification',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Document_Verification',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Document_Verification',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Document_Verification',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!CORE_DOCUMENT_VERIFICATION) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');

    initRef.current.dataTableHandled = true;
  }  

  }, [CORE_DOCUMENT_VERIFICATION]) ;


  
  
  var Ids = [];
  for(var Ele in CORE_DOCUMENT_VERIFICATION){
	  for(var Sec in CORE_DOCUMENT_VERIFICATION[Ele]){
		if(Sec == "id")
			Ids.push(CORE_DOCUMENT_VERIFICATION[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(CORE_DOCUMENT_VERIFICATION[Ele]["status"]);
		else if(Array.isArray(CORE_DOCUMENT_VERIFICATION[Ele][Sec]))
			  for(var Row in CORE_DOCUMENT_VERIFICATION[Ele][Sec])  // Convert to CORE_DOCUMENT_VERIFICATION[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in CORE_DOCUMENT_VERIFICATION[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["CORE_DOCUMENT_VERIFICATION"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewCORE_DOCUMENT_VERIFICATION(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DOCUMENT_VERIFICATION`).then((response1) => {
		if(!CORE_DOCUMENT_VERIFICATION) 
			setCORE_DOCUMENT_VERIFICATION(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DOCUMENT_VERIFICATION_D`).then((response2) => {
			setCORE_DOCUMENT_VERIFICATION_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddCORE_DOCUMENT_VERIFICATION_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewCORE_DOCUMENT_VERIFICATION = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DOCUMENT_VERIFICATION/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setCORE_DOCUMENT_VERIFICATION(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataCORE_DOCUMENT_VERIFICATION = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DOCUMENT_VERIFICATION/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutCORE_DOCUMENT_VERIFICATION = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DOCUMENT_VERIFICATION/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostCORE_DOCUMENT_VERIFICATION = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DOCUMENT_VERIFICATION', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteCORE_DOCUMENT_VERIFICATION = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DOCUMENT_VERIFICATION', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_0"]=value;
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_0",value,Temp_Data);
 	//handleLastDataCORE_DOCUMENT_VERIFICATION(Temp_Data);
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_1"]=value;
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_1",value,Temp_Data);
 	//handleLastDataCORE_DOCUMENT_VERIFICATION(Temp_Data);
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
 }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_2"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_2",value,Temp_Data);
 	//handleLastDataCORE_DOCUMENT_VERIFICATION(Temp_Data);
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
  }; 
  

    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_3"]=value;
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_3",value,Temp_Data);
 	//handleLastDataCORE_DOCUMENT_VERIFICATION(Temp_Data);
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
 }; 
  
  
      
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_3_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["3"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_3_0"]=value ? true : false; // optionally just use boolean
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
	Form_Data_onChange("3","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_3_0",value,Temp_Data);
 	//handleLastDataCORE_DOCUMENT_VERIFICATION(Temp_Data);
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
 }; 
  


    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["4"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_4_0"]=value;
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
	Form_Data_onChange("4","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_4_0",value,Temp_Data);
 	//handleLastDataCORE_DOCUMENT_VERIFICATION(Temp_Data);
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
 }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_0",value,Temp_Data);
 	//handleLastDataCORE_DOCUMENT_VERIFICATION(Temp_Data);
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
  }; 
  

    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_1"]=value;
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_1",value,Temp_Data);
 	//handleLastDataCORE_DOCUMENT_VERIFICATION(Temp_Data);
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_2"]=value;
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_2",value,Temp_Data);
 	//handleLastDataCORE_DOCUMENT_VERIFICATION(Temp_Data);
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_3"]=value;
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_3",value,Temp_Data);
 	//handleLastDataCORE_DOCUMENT_VERIFICATION(Temp_Data);
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_4"]=value;
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_4",value,Temp_Data);
 	//handleLastDataCORE_DOCUMENT_VERIFICATION(Temp_Data);
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
 }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));  
  Temp_Data['2'][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_0"] = value;
  setCORE_DOCUMENT_VERIFICATION(Temp_Data);
};


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_1_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));  
  Temp_Data['2'][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_1"] = value;
  setCORE_DOCUMENT_VERIFICATION(Temp_Data);
};

  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_2_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["2"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_2"]=value ? true : false;
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
  }; 


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
	Temp_Data["2"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_3"]=value;
    setCORE_DOCUMENT_VERIFICATION(Temp_Data);
	//handleAddCORE_DOCUMENT_VERIFICATION(Temp_Data,App_Data['CORE_DOCUMENT_VERIFICATION']);
  }; 
  



 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!CORE_DOCUMENT_VERIFICATION) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_0']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_1']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_2']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_3']='';
	    break;

  }


  const updatedCORE_DOCUMENT_VERIFICATION =JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
  updatedCORE_DOCUMENT_VERIFICATION[Sec] = [...updatedCORE_DOCUMENT_VERIFICATION[Sec], newRow];
  setCORE_DOCUMENT_VERIFICATION(updatedCORE_DOCUMENT_VERIFICATION);
};

const handleDeleteRow = (sec,index) => {
  const updatedCORE_DOCUMENT_VERIFICATION = JSON.parse(JSON.stringify(CORE_DOCUMENT_VERIFICATION));
  updatedCORE_DOCUMENT_VERIFICATION[sec].splice(index, 1);
  setCORE_DOCUMENT_VERIFICATION(updatedCORE_DOCUMENT_VERIFICATION);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Core Document Verification`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Document Verification ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Document Verification ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_0" type="text" className="form-control" placeholder="Document Verification ID" value={CORE_DOCUMENT_VERIFICATION["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_0`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Document Verification ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Document ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_1" type="text" className="form-control" placeholder="Document ID" value={CORE_DOCUMENT_VERIFICATION["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_1`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Document ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Verifier Stakeholder Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_2"  value={CORE_DOCUMENT_VERIFICATION["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_2`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_2_Change} className="form-control" name="Verifier Stakeholder Type"  >
						  <option value="Internal Reviewer">Internal Reviewer</option>
						  <option value="Title Company">Title Company</option>
						  <option value="Appraiser">Appraiser</option>
						  <option value="Inspector">Inspector</option>
						  <option value="Legal Counsel">Legal Counsel</option>
						  <option value="Escrow Agent">Escrow Agent</option>
						  <option value="Auditor">Auditor</option>
						  <option value="Compliance Officer">Compliance Officer</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Verifier Stakeholder Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Verifier ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_3" type="text" className="form-control" placeholder="Verifier ID" value={CORE_DOCUMENT_VERIFICATION["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_3`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Verifier ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_HEADER">{t(`Verification Issue Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Verification Issue Type`)}</th>
                        <th>{t(`Verification Status`)}</th>
                        <th>{t(`Deficiency Found`)}</th>
                        <th>{t(`Deficiency Description`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {CORE_DOCUMENT_VERIFICATION['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_0`]} data-search={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_0"  onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_0_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_0`]} name="Verification Issue Type">
						  <option value="Missing Document">Missing Document</option>
						  <option value="Expired Document">Expired Document</option>
						  <option value="Mismatch">Mismatch</option>
						  <option value="Unverified Source">Unverified Source</option>
						  <option value="Correction Required">Correction Required</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_1`]} data-search={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_1`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_1"  onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_1_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_1`]} name="Verification Status">
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Verified">Verified</option>
						  <option value="Failed">Failed</option>
						  <option value="Expired">Expired</option>
						  <option value="Waived">Waived</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_2"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_2_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_2`]  === true? e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_2`] : false  } />
						   </label>
						</td>
                        <td  data-order={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_3`]} data-search={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_3" type="text" onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_3_Change(ev, i)} className="form-control" value={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_2_3`]} placeholder="Deficiency Description"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Corrective Action Required`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_3_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_3_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Corrective Action Required`)} <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_3_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_3_0_Change} 
					  checked={CORE_DOCUMENT_VERIFICATION?.["3"]?.["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_3_0"] === "true" || CORE_DOCUMENT_VERIFICATION?.["3"]?.["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_3_0"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Verified At`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Verified At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_4_0" type="text" className="form-control" placeholder="Verified At" value={CORE_DOCUMENT_VERIFICATION["4"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_4_0`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Verified At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_0"  value={CORE_DOCUMENT_VERIFICATION["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_0`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_1" type="text" className="form-control" placeholder="Created By" value={CORE_DOCUMENT_VERIFICATION["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_1`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_2" type="text" className="form-control" placeholder="Created At" value={CORE_DOCUMENT_VERIFICATION["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_2`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_3" type="text" className="form-control" placeholder="Updated By" value={CORE_DOCUMENT_VERIFICATION["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_3`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_4" type="text" className="form-control" placeholder="Updated At" value={CORE_DOCUMENT_VERIFICATION["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_4`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DOCUMENT_VERIFICATION_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Core_Document_Verification;  